import { cn } from '@/app/utils'
import { AppLoader } from '@/components/shared/loader'

type Props = {
  unreadCount?: number
  isLoading?: boolean
}

export const NotificationUnreadFilter = ({ unreadCount, isLoading }: Props) => (
  <span
    className={cn(
      '-my-2 inline-flex h-28 min-w-[36px] items-center justify-center rounded-100 bg-bronze-40 py-2 align-middle font-bold',
      !isLoading && 'px-10'
    )}
  >
    {isLoading ? (
      <span className="flex h-14 w-14 items-center justify-center overflow-hidden">
        <AppLoader className="scale-[0.3]" noText variant="secondary" />
      </span>
    ) : (
      unreadCount ?? 0
    )}
  </span>
)
